<p ng-if="$ctrl.emptyMessage && (!$ctrl.config.items || !$ctrl.config.items.length)">{{$ctrl.emptyMessage}}</p>
<div class="list-filter" ng-if="$ctrl.config.showFilter">
    <div class="list-filter-fixed">
        <div class="list-filter-main">
            <div class="list-filter-tools" style="height: auto;overflow: visible;">
                <div centuri-list-filter class="list-filter-elements" config="$ctrl.config.filterConfig" callback="$ctrl.filterCallback">
                </div>
            </div>
            <div class="list-filter-status">
                <div class="list-filter-status-text">{{$ctrl.statusText}}</div>
                <button ng-if="$ctrl.selectedIds.length > 0" class="list-deselect-items" ng-click="$ctrl.deselectItems()">{{$ctrl.deselectText()}}</button>
            </div>
        </div>
    </div>
</div>
<c-items-list render-item-as="{{$ctrl.itemTemplate}}" options="$ctrl.options" items="$ctrl.items" selected-item-ids="$ctrl.selectedItemIds" total-count="$ctrl.totalCount" item-height="$ctrl.itemHeight" on-current-index="$ctrl.viewportIndex(index)" on-page-size="$ctrl.setPageSize(pageSize)" on-item-clicked="$ctrl.itemClicked(listId, item)" on-selected-changed="$ctrl.selectedChanged(listId, selectedIds, selectedItems, deselectedIds)" highlight="[$ctrl.searchInput]"></c-items-list>
